import { Col } from 'antd'
import PropTypes from 'prop-types'

import { ImageType } from '../types'
import { BynderPicture, CTALink, SquareBlock, Typography } from 'common/widgets'
import classNames from './styles.module.scss'


ImageItem.propTypes = {
  image: ImageType,
  subheading: PropTypes.string,
  heading: PropTypes.string,
  caption: PropTypes.string,
  tag: PropTypes.string,
  cta_link: PropTypes.string,
  cta_link_type: PropTypes.string,
}

export default function ImageItem({
  image = undefined,
  heading = undefined,
  subheading = undefined,
  caption = undefined,
  tag = undefined,
  cta_link: url = undefined,
  cta_link_type: ctaLinkType = undefined,
}) {
  return (
    <Col span={24} md={12} lg={8}>
      <SquareBlock
        containerClassName={classNames.container}
        innerClassName={classNames.inner}
        image={
          <BynderPicture
            priority
            image={image}
            desktopImage={{
              maxWidth: 550,
              maxHeight: 550,
              sizes: '(max-width: 765px) 100vw, (max-width: 1024px) 50vw, (max-width: 1920px) 33vw, 550px',
            }}
            mobileImage={{
              maxWidth: 550,
              maxHeight: 550,
              sizes: '100vw',
            }}
          />
        }
      >
        <Typography variant="content" color="white" className={classNames.name}><b>{tag}</b></Typography>
        <Typography variant="h3" color="white" className={classNames.name}>{heading}</Typography>
        <Typography color="white">{subheading}</Typography>
        <CTALink
          cta={caption}
          ctaURL={url}
          isUnderline
          type={ctaLinkType}
        />
      </SquareBlock>
    </Col>
  )
}
